import { render } from "./ProductOrderAnalysisSkeleton.vue?vue&type=template&id=c82875e8&scoped=true"
import script from "./ProductOrderAnalysisSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductOrderAnalysisSkeleton.vue?vue&type=script&lang=js"

import "./ProductOrderAnalysisSkeleton.vue?vue&type=style&index=0&id=c82875e8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82875e8"]])

export default __exports__